module.exports = __webpack_public_path__ + "img/film.37c331da.svg";